<template>
  <div style="background: white">
    <EducationHeader />
    <div class="breadBox">
      <a-breadcrumb>
        <span>
          <img src="@/assets/img/position.png" />
          当前位置：
        </span>
        <a-breadcrumb-item @click="onRollbackHome" style="cursor:pointer">首页</a-breadcrumb-item>
        <a-breadcrumb-item @click="onBackLevel" style="cursor:pointer">科研助理招聘</a-breadcrumb-item>
        <a-breadcrumb-item>科研助理招聘详情</a-breadcrumb-item>
      </a-breadcrumb>
    </div>
    <div class="tutorBox">
      <div class="logo">
        <img v-if="companyDetail.companyLogo" style="width: 100%;height: 100%;" :src="getImg(companyDetail.userLogo)" />
        <img v-else src="@/assets/img/defaultImg.png" alt="">
      </div>
      <div class="rightBox">
        <div class="tankName">{{ companyDetail.companyName }}</div>
        <div class="infoBox">
          <dict-render :dict-obj="dictObjs['businessScope']" v-if="companyDetail.businessScope"
            :text="companyDetail.businessScope"></dict-render> | <dict-render :dict-obj="dictObjs['projecttype']"
            v-if="companyDetail.companyProperty" :text="companyDetail.companyProperty"></dict-render> | {{
              companyDetail.registerMoney }}元
        </div>
        <div class="grayBox">
          <a-descriptions :column="3">
            <a-descriptions-item label="联系人">{{ companyDetail.linkman }}</a-descriptions-item>
            <a-descriptions-item label="企业地址" :span="2">{{ companyDetail.provject
            }}{{ companyDetail.detailedAddress }}</a-descriptions-item>
            <a-descriptions-item label="企业邮箱">{{ companyDetail.comEmail }}</a-descriptions-item>
            <a-descriptions-item label="注册时间" :span="2">{{ companyDetail.registerTime &&
              companyDetail.registerTime.split(' ')[0] }}</a-descriptions-item>
            <a-descriptions-item label="联系电话" :span="3">{{ companyDetail.phone }}</a-descriptions-item>
          </a-descriptions>
          <span>企业介绍：</span><a-typography-paragraph
            :ellipsis="ellipsis ? { rows: 2, expandable: true, symbol: '更多' } : false"
            :content="companyDetail.description" />
        </div>
      </div>
    </div>
    <div class="talentBox">
      <div class="talentLeftBox">
        <div class="talentTitleBox">
          <div class="talentTitle">
            招聘岗位
          </div>
        </div>
        <div class="talentContentBox">
          <a-collapse expand-icon-position="right" v-for="item in companyJobList" :key="item.id">
            <a-collapse-panel style="position: relative;" :key="item.id">
              <div class="applyBtn">
                <a-button type="primary" ghost v-if='isUserCode' @click="onPass(item)">申请岗位</a-button>
              </div>
              <div style="width: 80%;">
                <a-descriptions :column="3">
                  <a-descriptions-item label="学历">
                    <dict-render :dict-obj="dictObjs['education_background']"
                      :text="item.educationBackground"></dict-render>
                  </a-descriptions-item>
                  <a-descriptions-item label="工作年限" :span="2">
                    <dict-render :dict-obj="dictObjs['work_experience']" :text="item.workExperience"></dict-render>
                  </a-descriptions-item>
                  <a-descriptions-item label="福利待遇">
                    <dict-render :dict-obj="dictObjs['fringe_benefits']" v-if="item.welfareTreatment"
                      :text="item.welfareTreatment"></dict-render>
                  </a-descriptions-item>
                  <a-descriptions-item label="招聘人数" :span="2">{{ item.numberRecruits }}</a-descriptions-item>
                  <a-descriptions-item label="岗位职责" :span="3">{{ item.jobResponsibility }}</a-descriptions-item>
                  <a-descriptions-item label="任职要求" :span="3">{{ item.jobRequirements }}</a-descriptions-item>
                </a-descriptions>
              </div>
              <template #header>
                <div class="listBox">
                  <span class="jobName"><dict-render :dict-obj="dictObjs['hope_job']"
                      :text="item.jobTitle"></dict-render></span>
                  <span class="jobName"><dict-render :dict-obj="dictObjs['research_field']"
                      :text="item.industry"></dict-render></span>
                  <span class="salary"><dict-render :dict-obj="dictObjs['salary']"
                      :text="item.salary"></dict-render></span>
                  <p>期望入职时间：{{ item.expectedTimeEntry && item.expectedTimeEntry.split(' ')[0] }}</p>
                </div>
              </template>
            </a-collapse-panel>
          </a-collapse>
        </div>
      </div>
    </div>
    <LayoutFooter />
  </div>
</template>
<script>
import { dictMixin } from "@/mixins";
import EducationHeader from './educationHeader';
import { homeEducationInfo, jobRecommendation } from "@/api/educationService";
import DictRender from '@/components/other/DictRender';
import { file_service } from "@/api/adminService";
import LayoutFooter from '@/layout/layoutPage/footer/LayoutFooterNew2';
import { showCity } from "@/utils/util";
import { message } from "ant-design-vue";

export default {
  name: "noticeDetail",
  components: { EducationHeader, DictRender, LayoutFooter },
  mixins: [dictMixin],
  data() {
    return {
      dictNames: 'businessScope,projecttype,hope_job,salary,research_field,education_background,work_experience,fringe_benefits',
      companyJobList: {},
      companyDetail: {},
      ellipsis: true,
      isUserCode: false
    }
  },
  methods: {
    getDetail() {
      this.getAction({
        url: homeEducationInfo.companyJobList,
        params: { companyCode: this.$route.query.id }
      }).then(res => {
        this.companyJobList = res.records
      })
      this.getAction({
        url: homeEducationInfo.companyDetail,
        params: { companyCode: this.$route.query.id }
      }).then(res => {
        let obj = {
          ...res,
          provject: showCity(res.prov, res.city, res.dist),
        }
        this.companyDetail = obj
      })
    },
    onBackLevel() {
      this.$router.push({
        path: "/educationService/components/recruitment",
        query: { type: '科研助理招聘' }
      })
    },
    onRollbackHome() {
      this.$router.push({
        path: "/educationService/index",
        query: { type: '首页' }
      })
    },
    getImg(imgUrl) {
      return file_service.imagesWeb(imgUrl)
    },
    handleClick(event) {
      // If you don't want click extra trigger collapse, you can prevent this:
      event.stopPropagation();
    },
    onPass(record) {
      this.postAction({
        url: jobRecommendation.isPass,
        params: { id: record.id, companyCode: record.companyCode }
      }).then(() => {
        message.success("操作成功！")
      })
    }
  },
  mounted() {
    this.getDetail()
    this.isUserCode = this.$ls.get("roleCode").includes('user')
  }
}
</script>
<style lang="less" scoped>
.breadBox {
  width: 1200px;
  margin: 0 auto;
  padding: 20px 0;
  background: white;
}

.tutorBox {
  overflow: hidden;
  width: 1200px;
  margin: 0 auto;
  padding: 20px;
  border: 1px solid #dedede;

  .logo {
    float: left;
    width: 80px;
    height: 80px;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .rightBox {
    width: 90%;
    float: left;
    margin-left: 15px;

    .tankName {
      margin-bottom: 5px;
      font-size: 16px;
      color: #333;
    }

    .infoBox {
      margin-bottom: 15px;
      font-size: 14px;
      color: #666;
    }

    .grayBox {
      margin-bottom: 10px;
      font-size: 14px;
      color: #333;
    }
  }
}

.talentBox {
  overflow: hidden;
  width: 1200px;
  margin: 20px auto;

  .talentLeftBox {
    width: 100%;

    .talentTitleBox {
      overflow: hidden;
      width: 100%;
      padding: 15px 0 8px 0;
      border-bottom: 1px solid #dedede;

      .talentTitle {
        float: left;
        font-size: 20px;
        color: #333;
      }

      .talentTitle::before {
        content: '';
        padding-left: 12px;
        border-left: 4px solid #035aea;
      }
    }

    .talentContentBox {
      padding: 14px 0;
      width: 100%;

      .applyBtn {
        position: absolute;
        right: 10%;
        bottom: 30%;
      }

      .listBox {
        .jobName {
          margin-right: 15px;
          font-size: 16px;
          color: #333;
        }

        .salary {
          float: right;
          font-size: 16px;
          color: #ff9000;
          line-height: 60px;
        }

        p {
          margin-top: 15px;
        }
      }
    }
  }
}

:deep(.ant-descriptions-item) {
  padding-bottom: 6px;
}

:deep(.ant-descriptions-item-label) {
  font-size: 14px;
  color: #333;
}

:deep(.ant-descriptions-item-content) {
  font-size: 14px;
  color: #333;
}
</style>
